import { EmailChangeSearchParamsSchema } from '@onesource/schemas';
import { useCancelEmailChangeMutation } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { EmailChangeLoader } from 'src/components/email-change-loader';
import { AuthLayout } from 'src/layouts/auth';

export const Route = createFileRoute('/auth/cancel-email-change')({
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: '/auth/login' });
    }
  },
  validateSearch: EmailChangeSearchParamsSchema,
  component: CancelEmailChange,
});

function CancelEmailChange() {
  const { token } = Route.useSearch();
  const { mutateAsync } = useCancelEmailChangeMutation();
  const hasFired = useRef(false);

  useEffect(() => {
    if (!token || hasFired.current) {
      return;
    }
    hasFired.current = true;

    (async () => {
      try {
        await mutateAsync({ token, resetRedirectUrl: `${window.location.origin}/auth/reset-password` });
      } catch {
        // Hard refresh home regardless — the home route handles auth state.
      } finally {
        // Full reload so the app re-bootstraps the session/token after the change.
        window.location.href = '/';
      }
    })();
  }, [token, mutateAsync]);

  return (
    <AuthLayout>
      <EmailChangeLoader title="Cancelling the request…" subtitle="Hang tight, we'll take you home in a moment." />
    </AuthLayout>
  );
}
